import http from '@/plugins/http';

export default (params) => new Promise((res, rej) => {
  http.patch(`/v3/customers/${params.id}`, {
    payment_method: params.paymentMethod,
  })
    .then((response) => {
      res(response);
    })
    .catch((error) => {
      rej(error);
    });
});
